import type { IFormilySchema } from '../../types';
import { isArrayTableComponent, getSchemaFieldsV2 } from '../../utils';

export interface INestedArrayTableField {
  key: string;
  fieldDef: any;
}

export const getNestedArrayTableFields = (
  childSchema?: IFormilySchema
): INestedArrayTableField[] => {
  return getSchemaFieldsV2<INestedArrayTableField>(
    childSchema,
    fieldDef => isArrayTableComponent(fieldDef),
    (key, fieldDef) => ({
      key,
      fieldDef,
    })
  );
};
